import { isString } from 'lodash';
import { useQuery } from 'react-query';
import { StructuredActivityAssignment, StructuredActivityAssociatedMaterial } from 'domains/assignments/types';
import ContentService from 'utils/contentful/contentfulService';
import { TypeExpressableAcademyHomeworksFields } from 'types/contentful/clinical';

export const getStructuredActivity = (structuredActivityId: string) => {
  return ContentService.clients.clinical
    .getEntry<TypeExpressableAcademyHomeworksFields>(structuredActivityId, {
      include: 10,
    })
    .then(data => data.fields as TypeExpressableAcademyHomeworksFields);
};

export const useStructuredActivity = (structuredActivityId: string) => {
  return useQuery(['structured-activity', structuredActivityId], () => getStructuredActivity(structuredActivityId));
};

export const getAssociatedMaterial = ({
  materialContentfulEntryID,
  materialContentfulTitle,
  materialContentfulUrl,
}: StructuredActivityAssignment): StructuredActivityAssociatedMaterial | undefined => {
  if (isString(materialContentfulEntryID) && isString(materialContentfulTitle) && isString(materialContentfulUrl)) {
    return {
      materialContentfulEntryID,
      materialContentfulTitle,
      materialContentfulUrl,
    };
  }

  return undefined;
};
